/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { MapPin } from "lucide-react";

const TopSubcitiesChart = ({ data }) => {
  return (
    <div className="bg-slate-900 p-4 sm:p-5 rounded-2xl border border-slate-800 shadow-sm text-white">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-bold text-sm sm:text-base">Top Subcities</h3>
          <p className="text-xs text-white/60">Current period activity</p>
        </div>
        <div className="flex items-center gap-1">
          <span className="text-xs px-2 py-1 bg-blue-500/20 text-blue-300 rounded border border-blue-500/30">
            Time-filtered
          </span>
          <span className="text-xs px-2 py-1 bg-slate-700 rounded text-white/70">
            Top 5
          </span>
        </div>
      </div>

      {/* Compact Subcity List */}
      <div className="space-y-2">
        {data.length > 0 ? (
          data.map((subcity, index) => (
            <div
              key={subcity.name}
              className="flex items-center justify-between p-2 hover:bg-slate-800/50 rounded-lg transition-colors"
            >
              <div className="flex items-center gap-2 flex-1 min-w-0">
                <div className="w-6 h-6 rounded-md bg-slate-700 flex items-center justify-center text-xs font-bold text-white/70 flex-shrink-0">
                  {index + 1}
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium truncate">{subcity.name}</p>
                  <div className="flex items-center gap-1 mt-0.5">
                    <span className="text-xs px-1 py-0.5 bg-blue-500/20 text-blue-300 rounded border border-blue-500/30">
                      {subcity.bookings} bkgs
                    </span>
                    <span className="text-xs px-1 py-0.5 bg-purple-500/20 text-purple-300 rounded border border-purple-500/30">
                      {subcity.jobs} jobs
                    </span>
                  </div>
                </div>
              </div>
              <div className="text-right ml-2">
                <p className="font-bold text-sm">{subcity.totalActivity}</p>
                <p className="text-xs text-white/60">total</p>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-4 text-white/60 text-sm">
            No subcity data for this period
          </div>
        )}
      </div>

      {/* Summary Footer */}
      {data.length > 0 && (
        <div className="mt-4 pt-3 border-t border-slate-700">
          <div className="flex justify-between text-xs">
            <div className="flex items-center gap-2">
              <MapPin size={12} className="text-white/60" />
              <span className="text-white/70">
                Total bookings:{" "}
                {data.reduce((sum, sub) => sum + (sub.bookings || 0), 0)}
              </span>
            </div>
            <span className="text-blue-400 font-medium">
              {data.reduce((sum, sub) => sum + (sub.jobs || 0), 0)} jobs
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopSubcitiesChart;
